/* Component on the DayPage to display each Schedule Scene's data
 * Contains the ScheduleSceneInfo conponent to display the scenes extra info
 * Contains the ScheduleSceneCharacters conponent to display the scenes Characters
 * Contains the ScheduleSceneOrder conponent to re-order the Scenes shooting position  */
import React, { useState } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useHistory } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import { PostDropdown } from "../../../components/PostDropdown";
import ScheduleSceneCharactersBG from "./ScheduleSceneCharactersBG";
import ScheduleSceneInfo from "./ScheduleSceneInfo";
import ScheduleSceneOrder from "./ScheduleSceneOrder";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";

import styles from "../../../styles/ScheduleCreate.module.css";
import btnStyles from "../../../styles/Button.module.css";
import toast from "react-hot-toast";

const ScheduleScene = (props) => {
  const currentUser = useCurrentUser();
  const host = useHostName();
  const history = useHistory();
  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episodeid");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");
  const [show, setShow] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const {
    sceneAll,
    scene_id,
    id,
    day_id,
    number,
    int_ext,
    start_time,
    end_time,
    location,
    title,
    filming_location,
    day_night,
    action,
    pages,
    next,
    day_order_number,
    setHasOrder,
    style,
    showSideBySide,
    new_info,
  } = props;


  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/schedule/scenes/edit/${id}${epi && project && episodeTitle
        ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
        : ""
      }`
    );
  };

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/schedule/scenes/${id}/`);
        setHasOrder(true);
        toast.success(`Scene Deleted`);
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/schedule/scenes/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        toast.success(`Scene Deleted Successfully!`);
        setHasOrder(true);
      }
    } catch (err) { }
  };

  return (
    <div style={style} className={` ${styles.Bold} mx-0`}>
      <div className={`${styles.BottomScene2} d-none d-md-block px-0 mx-0`}>
        <Row className={`${styles.Bold} pt-2 text-center px-0 mx-0`}>
          <Col className={`mx-0 px-0 mt-0 pt-0 ${styles.TitleBox2}`} xs={1} md={1}>                
              {currentUser &&
                currentUser?.groups.length > 0 &&
                (currentUser?.groups[0]?.name === "Superadmin") ? (
              <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Quick Edit</Tooltip>}>
                <Button
                  onClick={() => setShowOrder((showOrder) => !showOrder)}
                  className={`${btnStyles.Button} ${btnStyles.Shed} py-0 px-3`}
                >
                  {day_order_number+1}
                </Button>
                </OverlayTrigger>
              ) : (
                <Button
                  className={`${btnStyles.Button} ${btnStyles.OrderN} py-0 px-3`}
                >
                  {day_order_number+1}
                </Button>
              )}
            
            {currentUser &&
              currentUser?.groups.length > 0 &&
              (currentUser?.groups[0]?.name === "Superadmin") && (
                <PostDropdown
                  className={`${styles.Drop}`}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              )}
          </Col>
          <Col className={`mx-0 px-0  ${styles.TitleBox2}`} xs={1} md={1}>
            <p className={`mb-0  ${styles.BoldScene}`}>{start_time}</p>
            <p className='mb-0'>{end_time}</p>
          </Col>
          <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">{number}</p>
          </Col>
          <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={4} md={4}>
            <p style={{ textTransform: "uppercase" }} className="mb-0">
              {int_ext} {location}
            </p>
            <div className={`mb-0 ${styles.Div30div}`}>
              <Row>
              <Col xs={{span: 8, offset: 2}}>
              <p style={{ fontStyle: 'italic'}}
            className={`mb-0 ${styles.Div30A}`}>{action}</p>
              </Col >
              </Row>
            </div>
          </Col>
          <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2} md={2}>
          <div className={`mb-0 ${styles.Div30div2}`}>
            <p className={`mb-0`}>{filming_location}</p>
            </div>
          </Col>
          <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p>{pages}</p>
          </Col>
          {/* cast */}
            <Col xs={1} md={1} className={`mx-0 px-0 ${styles.TitleBox2}`}>
              <Button
                onClick={() => setShow((show) => !show)}
                className={`${btnStyles.Button} ${btnStyles.Shed}`}
              >
                Cast
              </Button>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={1} md={1}>
              <Button
                onClick={() => setShowInfo((showInfo) => !showInfo)}
                className={`${btnStyles.Button} ${btnStyles.Shed}`}
              >
                Info
              </Button>
            </Col>
        </Row>
        {/* Order  */}
        {!showOrder ? (
          ""
        ) : (
          <ScheduleSceneOrder
            id={id}
            day_order_number1={day_order_number}
            scene_id1={scene_id}
            start_time1={start_time}
            end_time1={end_time}
            next1={next} 
            day_id1={day_id}
            setShowOrder={setShowOrder}
            setHasOrder={setHasOrder}
          />
        )}
        {/* cast  */}
        {!show ? "" : <ScheduleSceneCharactersBG scene_id={scene_id} />}
        {/* info */}
        <Row>
          <Col>
            {!showInfo ? "" : <ScheduleSceneInfo style={style} {...sceneAll} />}
          </Col>
        </Row>
        {/* next getBeginNext*/}
        {next ? (
          <Row className="px-3">
            <Col className={`mb-0 py-2 ${styles.Next1}`}>
              <p className="mb-0">Next: {next} </p>
            </Col>
          </Row>
        ) : (
          ""
        )}
      </div>
      {/* mobile */}
      <div className={`${styles.BottomScene} d-block d-md-none text-center mx-0`}>
        {/* time */}
        <Row className={`${styles.Bold} text-center py-1 mx-0`}>
          <Col className={`mx-0 px-0  ${styles.TitleBox2}`} xs={2}>
              <p className={`mb-0  ${styles.BoldScene}`}>{start_time}</p>
              <p className={`mb-0  ${styles.Para2}`}>{end_time}</p>
          </Col>
          <Col className={` mx-0 px-0 ${styles.TitleBox2}`} xs={8}>
              <p style={{ textTransform: 'uppercase'}} 
              className={`mb-0  ${styles.Para2}`}>{int_ext} {location}</p>
              <hr className={`${styles.HrSched} my-0 mx-3`}></hr>
              <p style={{ fontStyle: 'italic'}}
            className={`mb-0 ${styles.Div30M}`}>{filming_location}</p>
          </Col>
          <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2}>
              <p className={`mb-0  ${styles.Para2}`}>{number}</p>
          </Col>
        </Row>
        <hr className={`${styles.HrSched} my-0 mx-3`}></hr>
        {/* order - info -cast edit */}
        <Row className='my-1 mx-0 px-0 d-flex align-items-center '>
          {/* order */}
          <Col className='mx-0 px-0 d-flex align-items-center justify-content-center' xs={2}>
          {currentUser &&
                currentUser?.groups.length > 0 &&
                (currentUser?.groups[0]?.name === "Superadmin") ? (
              <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Quick Edit</Tooltip>}>
                <Button
                  onClick={() => setShowOrder((showOrder) => !showOrder)}
                  className={`${btnStyles.Button} ${btnStyles.OrderNN} py-0 px-2`}
                >
                  {day_order_number+1}
                </Button>
                </OverlayTrigger>
              ) : (
                <Button
                  className={`${btnStyles.Button} ${btnStyles.OrderNN} py-0 px-3`}
                >
                  {day_order_number+1}
                </Button>
              )}
          </Col>
          {/* info styles.Info */}
          <Col className={`mx-0 pl-0 pr-2`} xs={4}>
            <Button onClick={() => setShowInfo((showInfo) => !showInfo)}
            className={`${btnStyles.Button} ${btnStyles.Shed} py-0 px-3`}
            >INFO
            </Button>
          </Col>
          {/* cast text-left className={`${styles.Info}`} */}
          <Col className={`mx-0 pr-0 pl-2 `} xs={4}>
            <Button onClick={() => setShow((show) => !show)}
            className={`${btnStyles.Button} ${btnStyles.Shed} py-0 px-3`}
            >CAST
            </Button>
          </Col>
          <Col className={`text-center mx-0 px-0 mt-0 pt-0 ${styles.Icon}`} xs={2}>
            {
              !["Crew","Admincreative", "Admin"].includes(currentUser?.groups[0]?.name) &&
              <PostDropdown
                className={`${styles.Drop}`}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            }
          </Col>
        </Row>
        {/* cast */}
        {!show ? "" : <ScheduleSceneCharactersBG scene_id={scene_id} />}
        {/* info */}
        <Row>
          <Col>{!showInfo ? "" : <ScheduleSceneInfo {...sceneAll} />}</Col>
        </Row>
        {/* next */}
        {next ? (
          <Row>
            <Col className={`mb-0 py-2 ${styles.Next1}`}>
              <p className="mb-0">Next: {next} </p>
            </Col>
          </Row>
        ) : (
          ""
        )}
        {/* Order  */}
        {!showOrder ? (
          ""
        ) : (
          <ScheduleSceneOrder
            id={id}
            day_order_number1={day_order_number}
            scene_id1={scene_id}
            start_time1={start_time}
            end_time1={end_time}
            next1={next}
            day_id1={day_id}
            setShowOrder={setShowOrder}
            setHasOrder={setHasOrder}
          />
        )}
      </div>
    </div>
  );
};

export default ScheduleScene;
